// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Pi3f","row":"Node_row__2rOr2","label":"Node_label__2M-Ff","footer":"Node_footer__LmflJ"};